module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAAAXNSR0IArs4c6QAAANxJREFUWEftmLEKwjAQhu/q5OZbODh0ddQXcbJIBcU3KUSwSiuiL6KjowhC38TJ/OJuTQOFXuWy5pL78/HnQo7NJjsS84QkDODEJs0LIupL0EPEBSfJoRd0X8PAMjcpygaAfXaujYr4BkAFuWyhhJSQi4Brvl0eMmk+Y2DgOpXPPJgfy3i6K1tTSshs9yEBN59kVWMtEK7m0d2rMK7TbATic9UkPnFMGC/i6KKCyn2ihH476j88JO7af6CLKow+daXO2Ha9ZXWevOpeSshFSgm1j5C4r7S4ZoO0dswbVX1zvVXXNcoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/slt.png
// module id = +TdE
// module chunks = 0